export default function EFWashingMachine(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_8373_45763)">
                <path
                    d="M30.8125 5H9.1875C8.25552 5 7.5 5.75552 7.5 6.6875V33.3125C7.5 34.2445 8.25552 35 9.1875 35H30.8125C31.7445 35 32.5 34.2445 32.5 33.3125V6.6875C32.5 5.75552 31.7445 5 30.8125 5Z"
                    stroke=" currentColor"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.5 12.5H32.5" stroke=" currentColor" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.25 8.75H15" stroke=" currentColor" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <ellipse cx="27.5" cy="8.75" rx="1.25" ry="1.25" fill=" currentColor" />
                <path
                    d="M20 15.8438C24.3665 15.8438 27.9062 19.3835 27.9062 23.75C27.9062 28.1165 24.3665 31.6562 20 31.6562C15.6335 31.6562 12.0938 28.1165 12.0938 23.75C12.0938 19.3835 15.6335 15.8438 20 15.8438Z"
                    stroke=" currentColor"
                    strokeWidth="1.6875"
                />
                <path
                    d="M12.5 23.75C14.5799 22.2373 17.3672 22.1298 19.5574 23.4777L20 23.75L20.4426 24.0223C22.6328 25.3702 25.4201 25.2627 27.5 23.75"
                    stroke=" currentColor"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_8373_45763">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
